import { createContext, useState } from 'react';
import { useMedia, useMediaLayout } from 'use-media';
import { useIsomorphicLayoutEffect } from '../../hooks/useIsomorphicLayoutEffect.js';
import { useIsServer } from '../../hooks/useIsServer.js';
import { jsx } from 'react/jsx-runtime';

const PWAContext = /*#__PURE__*/createContext(undefined);
const PWAProvider = ({
  children
}) => {
  const isServer = useIsServer();
  const useMediaEffect = isServer ? useMedia : useMediaLayout;
  const [isPwa, setIsPwa] = useState(false);
  const isStandalone = useMediaEffect('(display-mode: standalone)');
  useIsomorphicLayoutEffect(() => {
    // @ts-ignore
    setIsPwa(isStandalone || window.navigator.standalone || document.referrer.startsWith('android-app://'));
  }, [isStandalone]);
  return /*#__PURE__*/jsx(PWAContext.Provider, {
    value: isPwa,
    children: children
  });
};

export { PWAContext, PWAProvider };
